"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchAdminAlertConfigDtoEmailScopeEnum = void 0;
exports.instanceOfPatchAdminAlertConfigDto = instanceOfPatchAdminAlertConfigDto;
exports.PatchAdminAlertConfigDtoFromJSON = PatchAdminAlertConfigDtoFromJSON;
exports.PatchAdminAlertConfigDtoFromJSONTyped = PatchAdminAlertConfigDtoFromJSONTyped;
exports.PatchAdminAlertConfigDtoToJSON = PatchAdminAlertConfigDtoToJSON;
exports.PatchAdminAlertConfigDtoToJSONTyped = PatchAdminAlertConfigDtoToJSONTyped;
/**
 * @export
 */
exports.PatchAdminAlertConfigDtoEmailScopeEnum = {
    Off: 'off',
    All: 'all',
    Ingestion: 'ingestion',
    Scraping: 'scraping'
};
/**
 * Check if a given object implements the PatchAdminAlertConfigDto interface.
 */
function instanceOfPatchAdminAlertConfigDto(value) {
    return true;
}
function PatchAdminAlertConfigDtoFromJSON(json) {
    return PatchAdminAlertConfigDtoFromJSONTyped(json, false);
}
function PatchAdminAlertConfigDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ingestionFailureThreshold': json['ingestionFailureThreshold'] == null ? undefined : json['ingestionFailureThreshold'],
        'scraperFailureThreshold': json['scraperFailureThreshold'] == null ? undefined : json['scraperFailureThreshold'],
        'dlqThreshold': json['dlqThreshold'] == null ? undefined : json['dlqThreshold'],
        'cooldownMinutes': json['cooldownMinutes'] == null ? undefined : json['cooldownMinutes'],
        'recipientEmails': json['recipientEmails'] == null ? undefined : json['recipientEmails'],
        'notificationChannels': json['notificationChannels'] == null ? undefined : json['notificationChannels'],
        'emailScope': json['emailScope'] == null ? undefined : json['emailScope'],
        'emailSubject': json['emailSubject'] == null ? undefined : json['emailSubject'],
        'emailIntro': json['emailIntro'] == null ? undefined : json['emailIntro'],
        'emailFooter': json['emailFooter'] == null ? undefined : json['emailFooter'],
    };
}
function PatchAdminAlertConfigDtoToJSON(json) {
    return PatchAdminAlertConfigDtoToJSONTyped(json, false);
}
function PatchAdminAlertConfigDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'ingestionFailureThreshold': value['ingestionFailureThreshold'],
        'scraperFailureThreshold': value['scraperFailureThreshold'],
        'dlqThreshold': value['dlqThreshold'],
        'cooldownMinutes': value['cooldownMinutes'],
        'recipientEmails': value['recipientEmails'],
        'notificationChannels': value['notificationChannels'],
        'emailScope': value['emailScope'],
        'emailSubject': value['emailSubject'],
        'emailIntro': value['emailIntro'],
        'emailFooter': value['emailFooter'],
    };
}
